import FastCashContainer from './FastCashContainer';

export default FastCashContainer;
